import classNames from 'classnames';
import getConfig from 'next/config';
import React from 'react';

import { SpecialOffers } from '@sravni/react-ugc/lib/SpecialOffers';
import { SpecialOffersForInsurance } from '@sravni/react-ugc/lib/SpecialOffersForInsurance';
import { useAnalytics, useIsMobile } from '@sravni/react-utils';
import { hasItem, makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS, COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { AB_NAME } from '../../pages/_app';

export interface ISpecialOffersProps {
  tabs: Tab[];
}

const { specialOffersUrl } = getConfig().publicRuntimeConfig;

export const SpecialOffersAndActionsBlock: React.FC<ISpecialOffersProps> = ({ tabs = [] }) => {
  const isMobile = useIsMobile();
  const { pushEvent } = useAnalytics();
  const isLoadRecentActions = hasItem(tabs, makeTab(ACTIONS.osago));
  const isVerticalOnMobile = tabs[0].type === COMMON_OFFERS.loan;

  const heading = <h2 className={isMobile ? 'article-h4' : 'article-h2'} />;

  const className = classNames('h-mt-20', isMobile ? 'h-mb-16' : 'h-mb-24');

  const props = {
    className,
    isWithButtons: true,
    heading,
    pushEvent,
    abName: AB_NAME,
    isNarrowOnDesktop: true,
    isVerticalOnMobile,
    iframeSrc: specialOffersUrl,
  };

  if (!tabs.length) return null;

  if (isLoadRecentActions) {
    return <SpecialOffersForInsurance {...props} />;
  }

  return <SpecialOffers {...props} tabs={tabs} />;
};
